import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col, Alert, Spinner } from "reactstrap";
import axios from "axios";
import _ from "lodash";
import Switch from "react-switch";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import Form from "../../../general/Form/Form";
import classes from './EditPlaceholderModal.module.scss'
import { boxiPrimary } from "../../../../assets/style/colors";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  truckName: null,
  campaignId: null,
  startingAddress: null,
  numStops: null,
  minMileage: null,
  maxMileage: null,
  minImpressions: null,
  maxImpressions: null,
  waypointGroupIds: [],
  useWeighting: false,
  waypointGroupWeightings: [0, 0, 0, 0],
  weightingError: "",
  loadedWaypoints: [],
  bridgeIds: [],
  loadedPlaceholderWaypointGroups: false,
  isRepRoute: false,
  waypointOneOption: null,
  waypointTwoOption: null,
  waypointThreeOption: null,
  waypointFourOption: null,
  toastHeader: "",
  toastBody: "",
  isToastOpen: false,
  loading: false
};

class EditPlaceholderModal extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    // Create a debounced version of the search function
    this.debouncedLoadOptions = _.debounce(this.loadWaypoints, 1000);
    this.debouncedLoadOptions1 = _.debounce(this.loadWaypoints, 1000);
    this.debouncedLoadOptions2 = _.debounce(this.loadWaypoints, 1000);
    this.debouncedLoadOptions3 = _.debounce(this.loadWaypoints, 1000);
  }

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    console.log("submit");
    // check if the total percentages of weightings is equal to 100 only if using weighting
    if (this.state.useWeighting) {
      let total = 0;
      let exists = false;
      this.state.waypointGroupWeightings.forEach((weight, index) => {
        // only add to total percentage if value exists and corresponding waypoint group id is selected
        if (this.state.waypointGroupIds[index]) {
          exists = true;
          total += weight;
        }
      });
      if (total !== 100 && exists) {
        let remaining = 100 - total;
        this.setState({
          weightingError: remaining > 0 ? `Allocate ${remaining}%` : `Remove ${remaining * -1}%`
        });
        return;
      } else {
        this.setState({
          weightingError: ""
        });
      }
    }
    let data = {
      name: this.state.truckName,
      campaign_id: this.state.campaignId,
      start_point: this.state.startingAddress,
      num_stops: this.state.numStops,
      min_mileage: this.state.minMileage,
      max_mileage: this.state.maxMileage,
      min_impressions: this.state.minImpressions,
      max_impressions: this.state.maxImpressions,
      use_weighting: this.state.useWeighting,
      is_macro: !this.state.isRepRoute
    };
    try {
      this.setState({
        loading: true
      })
      // update placeholder truck
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/placeholder/${this.props.id}`, data, config);
      if (res.status === 200 && res.data.updated_placeholder && res.data.updated_placeholder[0].placeholder_id) {
        // update/add any waypoint groups
        for (let i = 0; i < this.state.waypointGroupIds.length; i++) {
          let waypointId = this.state.waypointGroupIds[i] ? this.state.waypointGroupIds[i] : null;
          // if waypoint group was loaded, update the existing relationship
          if (this.state.loadedWaypoints[i]) {
            let bridgeId = this.state.bridgeIds[i] ? this.state.bridgeIds[i] : null;
            if (bridgeId) {
              let data = {
                placeholder_id: this.props.id,
                waypoint_group_id: waypointId,
                weighting: this.state.useWeighting ? this.state.waypointGroupWeightings[i] : 0
              };
              // if waypoint id exists, update the relationship
              if (data.waypoint_group_id) {
                let res = await axios.put(
                  `${process.env.REACT_APP_API_HOST}/placeholder_waypoint_bridge/${bridgeId}`,
                  data,
                  config
                );
                if (
                  !(res.status === 200 && res.data.updated_bridge && res.data.updated_bridge[0].placeholder_waypoint_bridge_id)
                )
                  return;
              } else {
                // otherwise, delete the relationship
                let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/placeholder_waypoint_bridge/${bridgeId}`, {
                  withCredentials: true
                });
                if (
                  !(res.status === 200 && res.data.deleted_bridge && res.data.deleted_bridge[0].placeholder_waypoint_bridge_id)
                )
                  return;
              }
            }
          } else {
            // otherwise create a new waypoint group to placeholder relationship
            if (waypointId) {
              let data = {
                weighting: this.state.useWeighting ? this.state.waypointGroupWeightings[i] : 0
              };
              let res = await axios.put(
                `${process.env.REACT_APP_API_HOST}/placeholder/${this.props.id}/waypoint_group/${waypointId}`,
                data,
                config
              );
              if (!(res.status === 200 && res.data.new_bridge && res.data.new_bridge[0].placeholder_waypoint_bridge_id)) return;
            }
          }
        }
        this.setState({
          toastHeader: 'Success',
          toastBody: 'Selected truck was updated!',
          isToastOpen: true,
          loading: false
        })
        this.toggle(null, true)
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
        }, 3000);
        // window.location.reload();
      } else if (res.status !== 200) {
        this.setState({
          toastHeader: 'Failure',
          toastBody: 'Problem updating selected truck!',
          isToastOpen: true,
          loading: false
        })
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
        }, 5000);
      }
    } catch (err) {
      console.log(err);
    }

    this.setState(initialState)
  };

  truckNameChangeHandler = (e) => {
    this.setState({
      truckName: e.target.value
    });
  };

  numStopChangeHandler = (e) => {
    this.setState({
      numStops: parseInt(e.target.value)
    });
  };

  minMileageChangeHandler = (e) => {
    this.setState({
      minMileage: parseInt(e.target.value)
    });
  };

  maxMileageChangeHandler = (e) => {
    this.setState({
      maxMileage: parseInt(e.target.value)
    });
  };
  
  minImpressionsChangeHandler = (e) => {
    this.setState({
      minImpressions: parseInt(e.target.value)
    });
  };

  maxImpressionsChangeHandler = (e) => {
    this.setState({
      maxImpressions: parseInt(e.target.value)
    });
  };

  useWeightingHandler = (value) => {
    this.setState({
      useWeighting: value
    });
  };

  waypointOneSelectHandler = (e) => {
    let waypoints = _.cloneDeep(this.state.waypointGroupIds);
    waypoints[0] = e.value
    this.setState({
      waypointGroupIds: waypoints,
      waypointOneOption: e
    });
  };

  waypointTwoSelectHandler = (e) => {
    let waypoints = _.cloneDeep(this.state.waypointGroupIds);
    waypoints[1] = e.value;
    this.setState({
      waypointGroupIds: waypoints,
      waypointTwoOption: e
    });
  };

  waypointThreeSelectHandler = (e) => {
    let waypoints = _.cloneDeep(this.state.waypointGroupIds);
    waypoints[2] = e.value;
    this.setState({
      waypointGroupIds: waypoints,
      waypointThreeOption: e
    });
  };

  waypointFourSelectHandler = (e) => {
    let waypoints = _.cloneDeep(this.state.waypointGroupIds);
    waypoints[3] = e.value;
    this.setState({
      waypointGroupIds: waypoints,
      waypointFourOption: e
    });
  };

  // waypointOneSelectHandler = (e) => {
  //   let waypoints = _.cloneDeep(this.state.waypointGroupIds);
  //   waypoints[0] = parseInt(e.target.value);
  //   this.setState({
  //     waypointGroupIds: waypoints
  //   });
  // };

  // waypointTwoSelectHandler = (e) => {
  //   let waypoints = _.cloneDeep(this.state.waypointGroupIds);
  //   waypoints[1] = parseInt(e.target.value);
  //   this.setState({
  //     waypointGroupIds: waypoints
  //   });
  // };

  // waypointThreeSelectHandler = (e) => {
  //   let waypoints = _.cloneDeep(this.state.waypointGroupIds);
  //   waypoints[2] = parseInt(e.target.value);
  //   this.setState({
  //     waypointGroupIds: waypoints
  //   });
  // };

  // waypointFourSelectHandler = (e) => {
  //   let waypoints = _.cloneDeep(this.state.waypointGroupIds);
  //   waypoints[3] = parseInt(e.target.value);
  //   this.setState({
  //     waypointGroupIds: waypoints
  //   });
  // };

  waypointOneWeightingHandler = (e) => {
    let weightings = _.cloneDeep(this.state.waypointGroupWeightings);
    weightings[0] = !e.target.value ? 0 : parseInt(e.target.value) > 100 ? 100 : parseInt(e.target.value);
    this.setState({
      waypointGroupWeightings: weightings
    });
  };

  waypointTwoWeightingHandler = (e) => {
    let weightings = _.cloneDeep(this.state.waypointGroupWeightings);
    weightings[1] = !e.target.value ? 0 : parseInt(e.target.value) > 100 ? 100 : parseInt(e.target.value);
    this.setState({
      waypointGroupWeightings: weightings
    });
  };

  waypointThreeWeightingHandler = (e) => {
    let weightings = _.cloneDeep(this.state.waypointGroupWeightings);
    weightings[2] = !e.target.value ? 0 : parseInt(e.target.value) > 100 ? 100 : parseInt(e.target.value);
    this.setState({
      waypointGroupWeightings: weightings
    });
  };

  waypointFourWeightingHandler = (e) => {
    let weightings = _.cloneDeep(this.state.waypointGroupWeightings);
    weightings[3] = !e.target.value ? 0 : parseInt(e.target.value) > 100 ? 100 : parseInt(e.target.value);
    this.setState({
      waypointGroupWeightings: weightings
    });
  };

  isRepRouteHandler = (value) => {
    this.setState({
      isRepRoute: value
    });
  };

  startingAddressChangeHandler = (e) => {
    this.setState({
      startingAddress: e.target.value
    });
  };

  toggle = (id, fetch) => {
    this.setState(initialState);
    this.props.toggleModal(id, fetch);
  };

  componentDidMount = async () => {
    console.log(this.props.waypointList)
    if (this.props.id && !this.state.loadedPlaceholderWaypointGroups) {
      try {
        // get placeholder truck
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/placeholder/${this.props.id}`, { withCredentials: true });
        if (res.status === 200 && res.data.placeholder && res.data.placeholder[0].placeholder_id) {
          let placeholder = res.data.placeholder[0];
          let waypoints = placeholder.waypoint_ids.map((item) => item[0]);
          let weights = placeholder.waypoint_ids.map((item) => item[1]);
          // Make call to server to get placeholder truck info
          console.log(this.props.waypointList.filter((item) => item.value ==  waypoints[0])[0]);
          this.setState({
            loadedPlaceholderWaypointGroups: true,
            truckName: placeholder.name,
            campaignId: placeholder.campaign_id,
            startingAddress: placeholder.start_point,
            numStops: placeholder.num_stops,
            minMileage: placeholder.min_mileage,
            maxMileage: placeholder.max_mileage,
            minImpressions: placeholder.min_impressions,
            maxImpressions: placeholder.max_impressions,
            loadedWaypoints: waypoints,
            waypointGroupIds: waypoints,
            waypointOneOption: this.props.waypointList.filter((item) => item.value ==  waypoints[0])[0],
            waypointTwoOption: this.props.waypointList.filter((item) => item.value ==  waypoints[1])[0],
            waypointThreeOption: this.props.waypointList.filter((item) => item.value ==  waypoints[2])[0],
            waypointFourOption: this.props.waypointList.filter((item) => item.value ==  waypoints[3])[0],
            waypointGroupWeightings: weights,
            bridgeIds: placeholder.bridge_ids,
            useWeighting: placeholder.use_weighting,
            isRepRoute: !placeholder.is_macro
          });

          await this.getWaypointGroupNames(placeholder.waypoint_ids)
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  getWaypointGroupNames = async (waypoint_ids) => {
    for (const [index, waypoint_id] of waypoint_ids.entries()) {
      try {
        // get waypoint group info
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/waypoint_group/${waypoint_id[0]}`, {
          withCredentials: true
        });
        if (res.status === 200 && res.data.waypoint && res.data.waypoint[0].waypoint_group_id) {
          let waypoint = res.data.waypoint[0];
          console.log(waypoint);
          if (index == 0) {
            this.setState({ waypointOneOption: {value: waypoint_id[0], label: waypoint.name}})
          } else if (index == 1) {
            this.setState({ waypointTwoOption: {value: waypoint_id[0], label: waypoint.name}})
          } else if (index == 2) {
            this.setState({ waypointThreeOption: {value: waypoint_id[0], label: waypoint.name}})
          } else if (index == 3) {
            this.setState({ waypointFourOption: {value: waypoint_id[0], label: waypoint.name}})
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  componentWillUnmount() {
    // Clear the debounce timer to avoid memory leaks
    this.debouncedLoadOptions.cancel();
    this.debouncedLoadOptions1.cancel();
    this.debouncedLoadOptions2.cancel();
    this.debouncedLoadOptions3.cancel();
  }

  async loadWaypoints(value, callback) {
    let waypoints = [];
    let waypointListKeyPairs = [];

    let params = {
      search: value
    }
    // get waypoing groups
    try {
      // this.setState({ waypointListLoading: true })
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/waypoint_group`, { params }, { withCredentials: true });
      waypoints =
        res.status === 200 && res.data.waypoints
          ? res.data.waypoints.map((waypoint) => {
              waypointListKeyPairs.push({
                value: waypoint.waypoint_group_id,
                label: waypoint.name,
              });
              return [waypoint.waypoint_group_id, waypoint.name];
            })
          : [];

      callback(waypointListKeyPairs);
    } catch (err) {
      console.log(err);
    }
  }

  createDebouncedLoadOptions = () => {
    return _.debounce(this.loadWaypoints, 1000);
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    const toggleLabelStyle = {
      display: "inline-block",
      position: "relative",
      top: "-7px",
      left: "10px"
    };

    const debouncedLoadOptions = this.createDebouncedLoadOptions();

    return (
      <>
        {this.state.toastHeader === 'Success' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <Modal isOpen={this.props.show} toggle={this.toggle} size="lg">
          <ModalHeader>Edit Selected Truck</ModalHeader>
          <ModalBody>
            <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
              <Row form className="mb-3">
                <Col xs={6}>
                  <FormGroup className="mb-2">
                    <Label>Selected Truck Name</Label>
                    <Input
                      type="text"
                      value={this.state.truckName ? this.state.truckName : ""}
                      onChange={this.truckNameChangeHandler}
                      placeholder="Enter truck name..."
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Truck Starting Address</Label>
                    <Input
                      type="text"
                      onChange={this.startingAddressChangeHandler}
                      value={this.state.startingAddress ? this.state.startingAddress : ""}
                      placeholder="Enter an address..."
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Minimum Mileage</Label>
                    <Input
                      type="number"
                      onChange={this.minMileageChangeHandler}
                      value={this.state.minMileage ? this.state.minMileage : ""}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Maximum Mileage</Label>
                    <Input
                      type="number"
                      onChange={this.maxMileageChangeHandler}
                      value={this.state.maxMileage ? this.state.maxMileage : ""}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Minimum Impressions</Label>
                    <Input
                      type="number"
                      onChange={this.minImpressionsChangeHandler}
                      value={this.state.minImpressions ? this.state.minImpressions : ""}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Maximum Impressions</Label>
                    <Input
                      type="number"
                      onChange={this.maxImpressionsChangeHandler}
                      value={this.state.maxImpressions ? this.state.maxImpressions : ""}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup>
                    <Label>Daily Number Of Stops</Label>
                    <Input
                      type="number"
                      onChange={this.numStopChangeHandler}
                      value={this.state.numStops ? this.state.numStops : ""}
                    />
                  </FormGroup>
                </Col>
                <Col style={{ marginTop: 12 }} xs={6}>
                  <FormGroup>
                    <br />
                    <Switch onColor={boxiPrimary} onChange={this.isRepRouteHandler} checked={this.state.isRepRoute} uncheckedIcon={true} />
                    <div style={toggleLabelStyle}>Rep Route</div>
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col xs={12}>
                  <Switch onColor={boxiPrimary} onChange={this.useWeightingHandler} checked={this.state.useWeighting} uncheckedIcon={false} />
                  <div style={toggleLabelStyle}>Use Waypoint Group Weighting</div>
                </Col>
                {this.state.weightingError ? (
                  <Col xs={12}>
                    <Label className="text-danger">
                      The sum of all waypoint group weightings must be 100% ({this.state.weightingError})
                    </Label>
                  </Col>
                ) : <></>}
              </Row>
              <Row form>
                <Col xs={6}>
                  <Row>
                    <Col xs={8}>
                      <FormGroup>
                        <Label>Waypoint Group A</Label>
                        {/* <Select
                          searchable={true}
                          autoload={true}
                          value={this.state.waypointOneOption ? this.state.waypointOneOption : ''}
                          options={this.props.waypointList}
                          onChange={this.waypointOneSelectHandler}
                        /> */}
                        <AsyncSelect
                          loadOptions={debouncedLoadOptions}
                          value={this.state.waypointOneOption}
                          onChange={this.waypointOneSelectHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <Label>%</Label>
                      <Input
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        onChange={this.waypointOneWeightingHandler}
                        value={this.state.waypointGroupWeightings[0] ? this.state.waypointGroupWeightings[0] : 0}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={8}>
                      <FormGroup>
                        <Label>Waypoint Group C</Label>
                        {/* <Select
                          searchable={true}
                          autoload={true}
                          value={this.state.waypointThreeOption ? this.state.waypointThreeOption : ''}
                          options={this.props.waypointList}
                          onChange={this.waypointThreeSelectHandler}
                        /> */}
                        <AsyncSelect
                          loadOptions={debouncedLoadOptions}
                          value={this.state.waypointThreeOption}
                          onChange={this.waypointThreeSelectHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <Label>%</Label>
                      <Input
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        onChange={this.waypointThreeWeightingHandler}
                        value={this.state.waypointGroupWeightings[2] ? this.state.waypointGroupWeightings[2] : 0}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col xs={8}>
                      <FormGroup>
                        <Label>Waypoint Group B</Label>
                        {/* <Select
                          searchable={true}
                          autoload={true}
                          value={this.state.waypointTwoOption ? this.state.waypointTwoOption : ''}
                          options={this.props.waypointList}
                          onChange={this.waypointTwoSelectHandler}
                        /> */}
                        <AsyncSelect
                          loadOptions={debouncedLoadOptions}
                          value={this.state.waypointTwoOption}
                          onChange={this.waypointTwoSelectHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <Label>%</Label>
                      <Input
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        onChange={this.waypointTwoWeightingHandler}
                        value={this.state.waypointGroupWeightings[1] ? this.state.waypointGroupWeightings[1] : 0}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={8}>
                      <FormGroup>
                        <Label>Waypoint Group D</Label>
                        {/* <Select
                          searchable={true}
                          autoload={true}
                          value={this.state.waypointFourOption ? this.state.waypointFourOption : ''}
                          options={this.props.waypointList}
                          onChange={this.waypointFourSelectHandler}
                        /> */}
                        <AsyncSelect
                          loadOptions={debouncedLoadOptions}
                          value={this.state.waypointFourOption}
                          onChange={this.waypointFourSelectHandler}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <Label>%</Label>
                      <Input
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        onChange={this.waypointFourWeightingHandler}
                        value={this.state.waypointGroupWeightings[3] ? this.state.waypointGroupWeightings[3] : 0}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            {/* {deleteButton} */}
            <Button color="primary" onClick={this.onFormSubmitHandler}>
              {this.state.loading ? 
                <Spinner animation="border" variant="light" size="sm" />
                :
                <span>Save</span> 
              }
            </Button>
            <Button color="secondary" onClick={this.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default EditPlaceholderModal;
